import PerfectScrollbar from "perfect-scrollbar/dist/perfect-scrollbar";
import Tab from "bootstrap/js/src/tab";
import Collapse from "bootstrap/js/src/collapse";

/**
 * For stuff that's small and doesn't require a lot of setting up
 */
export default class MiscComponentInitializer {
	constructor() {
		this.initTabs();
		this.initButtons();
		this.initCollapsibles();
		this.initSlideToComponents();
		this.initPerfectScrollbars();
		this.initStickySidebar();
	}

	initButtons() {
		const buttonEls = document.querySelectorAll(".btn:not(.no-arrow), .link--arrow-right");
		buttonEls.forEach(item => {
			if (item.querySelector(".fa-angle-right") === null) {
				const span = item.querySelector("span");
				if (span !== null) {
					const icon = document.createElement("i");
					icon.classList.add("fas", "fa-angle-right");
					icon.setAttribute("aria-hidden", "true");
					span.append(icon);
				}
			}
		});
	}


	initSlideToComponents() {
		const elements = [].slice.call(window.document.querySelectorAll("[data-action=slideTo]"));
		elements.forEach((el) => {
			el.addEventListener("click", (e) => {
				e.preventDefault();
				/**
				 *
				 * @type {HTMLElement}
				 */
				let $this = e.currentTarget;
				let $target = document.querySelector($this.getAttribute("data-target"));
				if ($target) {
					window.scrollTo({
						top: $target.offsetTop - thee.header.getHeight(),
						behavior: "smooth"
					});
				}
			});
		});
	}

	initTabs() {
		const triggerTabList = [].slice.call(document.querySelectorAll('ul.tabs > li'))
		triggerTabList.forEach((triggerEl, index) => {
			let autoOpenIndex = -1;
			const parentEl = triggerEl.parentElement;
			const tabTrigger = new Tab(triggerEl);
			const autoOpenAttr = parentEl.getAttribute("data-auto-open");
			if (autoOpenAttr && autoOpenAttr.length > 0) {
				autoOpenIndex = parseInt(autoOpenAttr);
			}

			triggerEl.addEventListener('click', (event) => {
				event.preventDefault();
				tabTrigger.show();
			});

			if (autoOpenIndex > -1 && index === autoOpenIndex) {
				tabTrigger.show();
			}
		});
	}

	initCollapsibles() {

		document.querySelectorAll("[data-toggle=collapse]")
			.forEach(item => {
				const target = document.querySelector(item.getAttribute("data-target"));
				if (target) {
					const collapse = new Collapse(target, {
						toggle: false
					});
					item.addEventListener("click", (e) => {
						if (target.classList.contains("show")) {
							item.setAttribute("aria-expanded", "false");
							item.classList.add("collapsed");
						}
						else {
							item.setAttribute("aria-expanded", "true");
							item.classList.remove("collapsed");
						}
						collapse.toggle();
					});
				}
			});
	}


	initPerfectScrollbars() {
		document.querySelectorAll(".scrollable").forEach((item, i) => {
			let id = "scrollable-" + i;
			item.classList.add(id);
			new PerfectScrollbar("." + id);
		});
	}

	initStickySidebar() {
		const sidebarEl = document.querySelector('.content-sidebar');
		if (sidebarEl) {
			const stickyEl = sidebarEl.querySelector('.sticky');
			if (stickyEl) {
				const padding = 40;
				window.addEventListener('load', (e) => {
					stickyEl.style.top = thee.header.getHeight() + padding + "px";
				});
				window.addEventListener('resize', (e) => {
					stickyEl.style.top = thee.header.getHeight() + padding + "px";
				});
			}
		}
	}
}
